import { DonorAction } from "./donor-action";

export interface IInactiveDonor {
    id: number,
    alias: string,
    birthDate: string,
    evaluationDate: string,
    donationType: number,
    isChainStarter: boolean,
    donationStartDate: string,
    donationEndDate: string,
    action: DonorAction
}
